import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-05df5b76"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  class: "page-container"
};
var _hoisted_2 = {
  class: "user-contest-detail-box"
};
var _hoisted_3 = {
  class: "page-inner-container"
};
var _hoisted_4 = {
  class: "left-content"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "user-name"
};
var _hoisted_7 = {
  class: "user-contest-tip"
};
var _hoisted_8 = {
  key: 0,
  class: "tip"
};
var _hoisted_9 = {
  key: 1,
  class: "tip"
};
var _hoisted_10 = {
  class: "right-content"
};
var _hoisted_11 = {
  class: "breadcrumbs"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "/", -1);
});
var _hoisted_13 = {
  key: 0,
  class: "title"
};
var _hoisted_14 = {
  key: 1,
  class: "title"
};
var _hoisted_15 = {
  class: "info-box"
};
var _hoisted_16 = {
  class: "item"
};
var _hoisted_17 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_18 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_19 = ["title"];
var _hoisted_20 = {
  class: "item"
};
var _hoisted_21 = {
  key: 0,
  class: "key"
};
var _hoisted_22 = {
  key: 1,
  class: "key"
};
var _hoisted_23 = {
  class: "value"
};
var _hoisted_24 = {
  class: "item"
};
var _hoisted_25 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_26 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_27 = {
  class: "value"
};
var _hoisted_28 = {
  class: "item"
};
var _hoisted_29 = {
  key: 0,
  class: "key"
};
var _hoisted_30 = {
  key: 1,
  class: "key"
};
var _hoisted_31 = {
  class: "value"
};
var _hoisted_32 = {
  class: "item"
};
var _hoisted_33 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_34 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_35 = {
  class: "value"
};
var _hoisted_36 = {
  class: "item"
};
var _hoisted_37 = {
  key: 0,
  class: "key"
};
var _hoisted_38 = {
  key: 1,
  class: "key"
};
var _hoisted_39 = {
  class: "value"
};
var _hoisted_40 = {
  class: "title"
};
var _hoisted_41 = /*#__PURE__*/_createTextVNode(" 个人信息 ");
var _hoisted_42 = {
  key: 0,
  class: "btn-box",
  style: {
    "float": "right"
  }
};
var _hoisted_43 = /*#__PURE__*/_createTextVNode(" 编辑信息 ");
var _hoisted_44 = {
  class: "info-box"
};
var _hoisted_45 = {
  key: 0,
  class: "item"
};
var _hoisted_46 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "考生id：", -1);
});
var _hoisted_47 = {
  class: "value"
};
var _hoisted_48 = {
  class: "item"
};
var _hoisted_49 = {
  key: 0,
  class: "key"
};
var _hoisted_50 = {
  key: 1,
  class: "key"
};
var _hoisted_51 = {
  class: "value"
};
var _hoisted_52 = {
  class: "item"
};
var _hoisted_53 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_54 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_55 = {
  class: "value"
};
var _hoisted_56 = {
  class: "item"
};
var _hoisted_57 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "报名学校：", -1);
});
var _hoisted_58 = {
  class: "value"
};
var _hoisted_59 = {
  key: 1,
  class: "item"
};
var _hoisted_60 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "学员性别：", -1);
});
var _hoisted_61 = {
  class: "value"
};
var _hoisted_62 = {
  class: "item"
};
var _hoisted_63 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "指导老师：", -1);
});
var _hoisted_64 = {
  class: "value"
};
var _hoisted_65 = {
  class: "item"
};
var _hoisted_66 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "报名手机号：", -1);
});
var _hoisted_67 = {
  class: "text-center"
};
var _hoisted_68 = {
  key: 0
};
var _hoisted_69 = /*#__PURE__*/_createTextVNode("点击按钮查看明手机号");
var _hoisted_70 = {
  class: "phone-text"
};
var _hoisted_71 = {
  key: 1
};
var _hoisted_72 = {
  class: "item"
};
var _hoisted_73 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "所在班级：", -1);
});
var _hoisted_74 = {
  class: "value"
};
var _hoisted_75 = {
  class: "item"
};
var _hoisted_76 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证件类型：", -1);
});
var _hoisted_77 = {
  class: "value"
};
var _hoisted_78 = {
  class: "item"
};
var _hoisted_79 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "在考年级：", -1);
});
var _hoisted_80 = {
  class: "value"
};
var _hoisted_81 = {
  class: "item"
};
var _hoisted_82 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证件号码：", -1);
});
var _hoisted_83 = {
  class: "text-center"
};
var _hoisted_84 = {
  key: 0
};
var _hoisted_85 = /*#__PURE__*/_createTextVNode("点击按钮查看明证件号码");
var _hoisted_86 = {
  class: "phone-text"
};
var _hoisted_87 = {
  key: 1
};
var _hoisted_88 = {
  key: 2,
  class: "item"
};
var _hoisted_89 = {
  key: 0,
  class: "key"
};
var _hoisted_90 = {
  key: 1,
  class: "key"
};
var _hoisted_91 = {
  key: 2,
  class: "value"
};
var _hoisted_92 = {
  key: 3,
  class: "value"
};
var _hoisted_93 = {
  key: 3,
  class: "post-methods"
};
var _hoisted_94 = {
  class: "item"
};
var _hoisted_95 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "证书获取方式：", -1);
});
var _hoisted_96 = {
  class: "value"
};
var _hoisted_97 = {
  key: 0,
  class: "item"
};
var _hoisted_98 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "证书邮寄地址：", -1);
});
var _hoisted_99 = {
  class: "value"
};
var _hoisted_100 = {
  key: 2,
  class: "title"
};
var _hoisted_101 = {
  key: 3,
  class: "title"
};
var _hoisted_102 = {
  class: "info-box"
};
var _hoisted_103 = {
  class: "item"
};
var _hoisted_104 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_105 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_106 = {
  class: "value"
};
var _hoisted_107 = {
  class: "item"
};
var _hoisted_108 = {
  key: 0,
  class: "key"
};
var _hoisted_109 = {
  key: 1,
  class: "key"
};
var _hoisted_110 = {
  class: "value"
};
var _hoisted_111 = {
  class: "item"
};
var _hoisted_112 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_113 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_114 = {
  class: "value"
};
var _hoisted_115 = {
  class: "item"
};
var _hoisted_116 = {
  key: 0,
  class: "key"
};
var _hoisted_117 = {
  key: 1,
  class: "key"
};
var _hoisted_118 = {
  class: "value"
};
var _hoisted_119 = {
  class: "item"
};
var _hoisted_120 = {
  key: 0,
  class: "key left-key"
};
var _hoisted_121 = {
  key: 1,
  class: "key left-key"
};
var _hoisted_122 = {
  class: "value"
};
var _hoisted_123 = {
  key: 0,
  class: "item"
};
var _hoisted_124 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "是否晋级：", -1);
});
var _hoisted_125 = {
  class: "value"
};
var _hoisted_126 = {
  class: "item"
};
var _hoisted_127 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "本次得分：", -1);
});
var _hoisted_128 = {
  class: "value"
};
var _hoisted_129 = {
  key: 0,
  class: "clearboth"
};
var _hoisted_130 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, null, -1);
});
var _hoisted_131 = {
  key: 1,
  class: "item item32"
};
var _hoisted_132 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "是否得奖：", -1);
});
var _hoisted_133 = {
  class: "value"
};
var _hoisted_134 = /*#__PURE__*/_createTextVNode("查看证书");
var _hoisted_135 = {
  key: 0,
  class: "clearboth"
};
var _hoisted_136 = {
  class: "item item32"
};
var _hoisted_137 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key left-key"
  }, "答辩时间：", -1);
});
var _hoisted_138 = {
  class: "value"
};
var _hoisted_139 = /*#__PURE__*/_createTextVNode("开始答辩");
var _hoisted_140 = {
  key: 1
};
var _hoisted_141 = {
  key: 2,
  class: "item item32"
};
var _hoisted_142 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "key"
  }, "赛事类型：", -1);
});
var _hoisted_143 = {
  class: "value"
};
var _hoisted_144 = /*#__PURE__*/_createTextVNode("模拟赛");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_router_link = _resolveComponent("router-link");
  var _component_a_divider = _resolveComponent("a-divider");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_popover = _resolveComponent("a-popover");
  var _component_a_tag = _resolveComponent("a-tag");
  var _component_a_row = _resolveComponent("a-row");
  var _component_UserCertificate = _resolveComponent("UserCertificate");
  return _ctx.userExam ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_a_row, {
    type: "flex",
    gutter: 44,
    wrap: false
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        flex: "188px"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createElementVNode("img", {
            class: "user-avatar",
            src: _ctx.isNocFlag ? _ctx.HetaoDefaultAvatar : _ctx.userService.user && _ctx.userService.user.avatar
          }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.userService.user && _ctx.userService.user.mobile), 1), _createElementVNode("div", _hoisted_7, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_8, "我的比赛")) : (_openBlock(), _createElementBlock("div", _hoisted_9, "我的活动"))])])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        flex: "auto"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_router_link, {
            to: _ctx.myCompetionRoute,
            class: "tip"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.isNocFlag ? '我的比赛' : '我的活动'), 1)];
            }),
            _: 1
          }, 8, ["to"]), _hoisted_12, _createElementVNode("span", null, _toDisplayString(_ctx.userExam.contestInfoName), 1)]), _ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_13, "比赛信息")) : (_openBlock(), _createElementBlock("div", _hoisted_14, "活动信息")), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_17, "比赛名称：")) : (_openBlock(), _createElementBlock("div", _hoisted_18, "活动名称：")), _createElementVNode("div", {
            class: "value",
            title: "".concat(_ctx.userExam.contestInfoName)
          }, [_createElementVNode("span", null, _toDisplayString(_ctx.userExam.contestInfoName), 1)], 8, _hoisted_19)]), _createElementVNode("div", _hoisted_20, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_21, "比赛项：")) : (_openBlock(), _createElementBlock("div", _hoisted_22, "活动项：")), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.userExam.contestItemName), 1)]), _createElementVNode("div", _hoisted_24, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_25, "比赛类型：")) : (_openBlock(), _createElementBlock("div", _hoisted_26, "活动类型：")), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.userExam.activityTypeDesc), 1)]), _createElementVNode("div", _hoisted_28, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_29, "比赛阶段：")) : (_openBlock(), _createElementBlock("div", _hoisted_30, "活动阶段：")), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.userExam.contestStageName || '--'), 1)]), _createElementVNode("div", _hoisted_32, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_33, " 比赛开始时间： ")) : (_openBlock(), _createElementBlock("div", _hoisted_34, "活动开始时间：")), _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.startTime)), 1)]), _createElementVNode("div", _hoisted_36, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_37, "比赛结束时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_38, "活动结束时间：")), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.endTime)), 1)])]), _createVNode(_component_a_divider, {
            style: {
              "height": "2px",
              "background-color": "#f3f5f8",
              "margin": "16px 0"
            }
          }), _createElementVNode("div", _hoisted_40, [_hoisted_41, _ctx.canShowEidtBtn ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_a_button, {
            type: "default",
            shape: "round",
            onClick: _ctx.changeInfo
          }, {
            default: _withCtx(function () {
              return [_hoisted_43];
            }),
            _: 1
          }, 8, ["onClick"])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_44, [!_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_45, [_hoisted_46, _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.userExam.userId), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_49, "选手所在地区：")) : (_openBlock(), _createElementBlock("div", _hoisted_50, "考生所在地区：")), _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.userExam.activityId === 259 ? _ctx.userExam.area.slice(0, _ctx.userExam.area.lastIndexOf('-')) : _ctx.userExam.area), 1)]), _createElementVNode("div", _hoisted_52, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_53, "选手姓名：")) : (_openBlock(), _createElementBlock("div", _hoisted_54, "考生姓名：")), _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.userExam.userName || '--'), 1)]), _createElementVNode("div", _hoisted_56, [_hoisted_57, _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.userExam.school || '--'), 1)]), _ctx.userExam.activityId !== 259 ? (_openBlock(), _createElementBlock("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.value2label(_ctx.userExam.sex, _ctx.SEX, '--')), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_62, [_hoisted_63, _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.userExam.teacherName || '--'), 1)]), _createElementVNode("div", _hoisted_65, [_hoisted_66, _ctx.userExam.cardNo ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            title: "查看明文手机号",
            trigger: "click",
            onVisibleChange: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.userExamService.plainText = '';
            })
          }, {
            content: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_67, [_ctx.userExamService.plainText ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(_ctx.userExamService.plainText), 1)) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.getPlantTextString('phone');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_69];
                }),
                _: 1
              }))])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_70, _toDisplayString(_ctx.userExam.mobile), 1)];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_71, "--"))]), _createElementVNode("div", _hoisted_72, [_hoisted_73, _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.userExam.className || '--'), 1)]), _createElementVNode("div", _hoisted_75, [_hoisted_76, _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.value2label(_ctx.userExam.cardType, _ctx.CARD_TYPE, '--')), 1)]), _createElementVNode("div", _hoisted_78, [_hoisted_79, _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.value2label(_ctx.userExam.grade, _ctx.GRADE, '--')), 1)]), _createElementVNode("div", _hoisted_81, [_hoisted_82, _ctx.userExam.cardNo ? (_openBlock(), _createBlock(_component_a_popover, {
            key: 0,
            title: "查看明文证件号码",
            trigger: "click",
            onVisibleChange: _cache[3] || (_cache[3] = function ($event) {
              return _ctx.userExamService.plainText = '';
            })
          }, {
            content: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_83, [_ctx.userExamService.plainText ? (_openBlock(), _createElementBlock("span", _hoisted_84, _toDisplayString(_ctx.userExamService.plainText), 1)) : (_openBlock(), _createBlock(_component_a_button, {
                key: 1,
                type: "primary",
                onClick: _cache[2] || (_cache[2] = function ($event) {
                  return _ctx.getPlantTextString('idcode');
                })
              }, {
                default: _withCtx(function () {
                  return [_hoisted_85];
                }),
                _: 1
              }))])];
            }),
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.userExam.cardNo), 1)];
            }),
            _: 1
          })) : (_openBlock(), _createElementBlock("div", _hoisted_87, "--"))]), _ctx.userExam.cardType !== 1 ? (_openBlock(), _createElementBlock("div", _hoisted_88, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_89, "选手出生年月：")) : (_openBlock(), _createElementBlock("div", _hoisted_90, "考生出生年月：")), _ctx.userExam.birthday ? (_openBlock(), _createElementBlock("div", _hoisted_91, _toDisplayString(_ctx.userExam.birthday.substr(0, 4)) + "-" + _toDisplayString(_ctx.userExam.birthday.substr(4, 2)) + "-" + _toDisplayString(_ctx.userExam.birthday.substr(6, 2)), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_92, "--"))])) : _createCommentVNode("", true), !_ctx.hideGetCertification && !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_hoisted_95, _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.value2label(_ctx.userExam.certificateGetMethod, _ctx.CERTIFICATE_GET_METHODS, '--')), 1)]), _ctx.userExam.certificateGetMethod === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_97, [_hoisted_98, _createElementVNode("div", _hoisted_99, _toDisplayString(_ctx.userExam.certificatePostAddress || '--'), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createVNode(_component_a_divider, {
            style: {
              "height": "2px",
              "background-color": "#f3f5f8",
              "margin": "16px 0"
            }
          }), _ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_100, "比赛信息")) : (_openBlock(), _createElementBlock("div", _hoisted_101, "活动信息")), _createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_104, "比赛组别：")) : (_openBlock(), _createElementBlock("div", _hoisted_105, "活动组别：")), _createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.userExam.contestScheduledName), 1)]), _createElementVNode("div", _hoisted_107, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_108, "比赛开始时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_109, "考试开始时间：")), _createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.beginAnswerTime)), 1)]), _createElementVNode("div", _hoisted_111, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_112, "比赛耗时：")) : (_openBlock(), _createElementBlock("div", _hoisted_113, "活动耗时：")), _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.costTimeText), 1)]), _createElementVNode("div", _hoisted_115, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_116, "比赛结束时间：")) : (_openBlock(), _createElementBlock("div", _hoisted_117, "考试结束时间：")), _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.formatDateToSecond(_ctx.userExam.commitAnswerTime)), 1)]), _createElementVNode("div", _hoisted_119, [_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_120, "比赛阶段：")) : (_openBlock(), _createElementBlock("div", _hoisted_121, "活动阶段：")), _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.userExam.contestStageName || '--'), 1)]), !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_hoisted_124, _createElementVNode("div", _hoisted_125, _toDisplayString(_ctx.passedText), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_126, [_hoisted_127, _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.userExam.scoreDesc || (_ctx.userExam.totalScore === null ? '--' : _ctx.userExam.totalScore)), 1), _ctx.userExam.mockQueryScoreDesc ? (_openBlock(), _createElementBlock("div", _hoisted_129, [_hoisted_130, _createTextVNode(" " + _toDisplayString(_ctx.userExam.mockQueryScoreDesc), 1)])) : _createCommentVNode("", true)]), !_ctx.isNocFlag ? (_openBlock(), _createElementBlock("div", _hoisted_131, [_hoisted_132, _createElementVNode("div", _hoisted_133, [_createElementVNode("span", null, _toDisplayString(_ctx.awardedText), 1), _ctx.userExam.awarded === 2 && _ctx.userExam.certiPicture ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "default",
            shape: "round",
            class: "ml8",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return _ctx.showUserCertificate.visible = true;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_134];
            }),
            _: 1
          })) : _createCommentVNode("", true)]), _ctx.userExam.mockQueryScoreDesc ? (_openBlock(), _createElementBlock("div", _hoisted_135)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_136, [_hoisted_137, _createElementVNode("div", _hoisted_138, [_ctx.userExam.defenceStatus === 2 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "primary",
            shape: "round",
            class: "ml8",
            onClick: _ctx.goToExamAnswer
          }, {
            default: _withCtx(function () {
              return [_hoisted_139];
            }),
            _: 1
          }, 8, ["onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_140, _toDisplayString(_ctx.userExam.defenceTimePeriod || '--'), 1))])]), _ctx.userExam.examType === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_141, [_hoisted_142, _createElementVNode("div", _hoisted_143, [_createVNode(_component_a_tag, {
            class: "pos-tag",
            color: "#fc5000"
          }, {
            default: _withCtx(function () {
              return [_hoisted_144];
            }),
            _: 1
          })])])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])]), _ctx.userExam.userExamId ? (_openBlock(), _createBlock(_component_UserCertificate, {
    key: _ctx.userExam.userExamId,
    show: _ctx.showUserCertificate,
    userExamId: _ctx.userExam.userExamId
  }, null, 8, ["show", "userExamId"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
}